var exports = {
  "i": "xaee3c4fa--b675c8--wrapper",
};

module.exports = exports;
